export default __webpack_public_path__ + "static/Mother-with-her-newborn-baby-son-sitting-on-bed-400w-217a59fcd89ee95c0d341f3dc387d4e9.jpg";